/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostGuestPrototypesPartialsByProjectIdAndPrototypeIdParams,
  PostGuestPrototypesPartialsBatchByProjectIdAndPrototypeIdParams,
  PostGuestPrototypesPartialsBatchByProjectIdAndPrototypeIdQuery,
  PostGuestPrototypesPartialsByProjectIdAndPrototypeIdBody,
  PostGuestPrototypesPartialsByProjectIdAndPrototypeIdResponse,
  PostGuestPrototypesPartialsBatchByProjectIdAndPrototypeIdResponse,
} from '../types';

export class GuestPartials extends Controller {
  async postGuestPrototypesPartialsByProjectIdAndPrototypeId<
    T extends PostGuestPrototypesPartialsByProjectIdAndPrototypeIdResponse,
    D,
    C extends PostGuestPrototypesPartialsByProjectIdAndPrototypeIdBody
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PostGuestPrototypesPartialsByProjectIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/guest/${projectId}/prototypes/${prototypeId}/partials`,
      body,
      axiosConfig
    );
  }

  async postGuestPrototypesPartialsBatchByProjectIdAndPrototypeId<
    T extends PostGuestPrototypesPartialsBatchByProjectIdAndPrototypeIdResponse,
    D,
    C extends null
  >(
    body: C,
    {
      projectId,
      prototypeId,
    }: PostGuestPrototypesPartialsBatchByProjectIdAndPrototypeIdParams,
    query: PostGuestPrototypesPartialsBatchByProjectIdAndPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/guest/${projectId}/prototypes/${prototypeId}/partials/batch`,
        query
      ),
      body,
      axiosConfig
    );
  }
}
